// extracted by mini-css-extract-plugin
export default {"container":"style_container__nfiNk","page":"style_page__qygZB","error":"style_error__O3DnY"};